import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
export function TimeSmallRender(component, index) {
    return _jsx(TimeSmallWidget, {});
}
var TimeSmallWidget = function () { return (_jsx(Components.Refresh, { afterMs: 500, children: function () { return (_jsxs(_Fragment, { children: [_jsx(DateTime, {}), _jsx(DayInfo, {})] })); } })); };
export function TimeFullRender(component, index) {
    return _jsx(TimeFullWidget, {});
}
var TimeFullWidget = function () { return (_jsx(Components.Refresh, { afterMs: 500, children: function () { return (_jsxs(_Fragment, { children: [_jsx(DateTime, {}), _jsx(DayInfo, {}), _jsx(WorkingDay, {})] })); } })); };
export function TimeFrameRender(component, index) {
    return _jsx(TimeFrameWidget, {});
}
var TimeFrameWidget = function () { return (_jsx(Components.Refresh, { afterMs: 500, children: function () { return (_jsx(DateTime, {})); } })); };
function DateTime() {
    var date = new Date();
    return (_jsxs(_Fragment, { children: [_jsx("h4", { children: getDayString(date) }), _jsx("h1", { children: date.toLocaleTimeString() })] }));
}
function DayInfo() {
    var _a;
    var context = Common.useSpaContext();
    var dayInfo = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.day;
    if (!(dayInfo === null || dayInfo === void 0 ? void 0 : dayInfo.holiday) || (dayInfo === null || dayInfo === void 0 ? void 0 : dayInfo.holiday) === '-') {
        return (_jsx(Components.Property, { title: _jsx(Components.MLT, { cs: "St\u00E1tek m\u00E1", en: "Name day" }), children: dayInfo === null || dayInfo === void 0 ? void 0 : dayInfo.nameDay }, "1"));
    }
    else {
        return (_jsx(Components.Property, { title: _jsx(Components.MLT, { cs: "Dnes je", en: "Holiday" }), children: dayInfo === null || dayInfo === void 0 ? void 0 : dayInfo.holiday }, "2"));
    }
}
function WorkingDay() {
    var _a;
    var context = Common.useSpaContext();
    var dayInfo = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.day;
    return (_jsx(Components.Property, { title: _jsx(Components.MLT, { cs: "Pracovn\u00ED den", en: "Is working day" }), children: _jsx(Components.BooleanText, { value: dayInfo === null || dayInfo === void 0 ? void 0 : dayInfo.isWorkingDay }) }, "3"));
}
function getDayString(date) {
    var dayNames = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];
    var dayOfWeek = dayNames[date.getDay()];
    return dayOfWeek + ' ' + date.toLocaleDateString();
}
